import { snackbarTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';
import useProject from '@API/project/useProject';
import useExpDetailsPersonalTemplate from '@experiment-details/hooks/template/useExpDetailsPersonalTemplate';
import useExpTemplateList from '@experiment-details/hooks/template/useExpTemplateList';
import useRemoveExpDetailsTemplate from '@experiment-details/hooks/template/useRemoveExpDetailsTemplate';
import { AUTO_GENERATED_OPTION_ID } from '@shared/constants';
import { useDispatch } from 'react-redux';

const useExpDetailsPersonalViewOption = () => {
  const dispatch = useDispatch();
  const { data: project } = useProject();
  const { templateData: personalTemplate } = useExpDetailsPersonalTemplate();
  const { data: templateList = [] } = useExpTemplateList();
  const deleteTemplateMutation = useRemoveExpDetailsTemplate();

  const isDefault = !templateList
    .filter(template => template.projectId === project?.projectId)
    .some(temp => !temp.personalView && temp.defaultTemplate);

  const isFrozen =
    personalTemplate?.chartTemplate.panels.autoGenerate === false;
  const templateId = personalTemplate?.templateId || AUTO_GENERATED_OPTION_ID;

  const defaultView = {
    name: 'Personal view',
    frozen: isFrozen,
    id: templateId,
    isAutogenerated: true,
    isDefault
  };

  const onRegenerateDefaultView = async () => {
    if (deleteTemplateMutation.isLoading || !personalTemplate) return;

    deleteTemplateMutation.mutate(
      {
        templateId: templateId,
        projectId: personalTemplate.projectId
      },
      {
        onSuccess: () => {
          dispatch(
            alertsUtil.openSnackbarDialog(
              snackbarTypes.SUCCESS_API_RESPONSE,
              `Personal view is up to date.`
            )
          );
        }
      }
    );
  };

  return { onRegenerateDefaultView, defaultView };
};

export default useExpDetailsPersonalViewOption;
